import { Button, Popover, PopoverTrigger, Stack } from '@ekhodealer/ekho-common/rev';

import ChevronDown12 from '@common/components/icons/ChevronDown12';
import { TextCell } from '@common/components/TextCell';

import { PartsGarmentsAndAccessoriesContent } from '../order-details/PartsGarmentsAndAccessoriesSection';

interface PartsGarmentsAndAccessoriesCellProps {
	displayText?: string;
	purchasedVehicleId: string;
	itemsCount?: number;
}

const PopoverContent = ({ purchasedVehicleId }: { purchasedVehicleId: string }) => {
	return (
		<div style={{ width: 360 }}>
			<Stack itemsSpacing='8'>
				<PartsGarmentsAndAccessoriesContent purchasedVehicleId={purchasedVehicleId} />
			</Stack>
		</div>
	);
};

export const PartsGarmentsAndAccessoriesCell = ({
	displayText,
	purchasedVehicleId,
	itemsCount,
}: PartsGarmentsAndAccessoriesCellProps) => {
	// If there are no items, just show the text without the dropdown
	if (!itemsCount || itemsCount === 0) {
		return <TextCell value={displayText} />;
	}

	// PopoverContent only renders when popover is open, so the hook will only be called then
	return (
		<PopoverTrigger>
			<Button
				className='pga-cell'
				variant='ghost'
				size='xlarge'
				rounding='0'
				icon={<ChevronDown12 />}
				iconSide='right'>
				<TextCell value={displayText} />
			</Button>
			<Popover offset={-12} crossOffset={-4}>
				<PopoverContent purchasedVehicleId={purchasedVehicleId} />
			</Popover>
		</PopoverTrigger>
	);
};
